class Config {
  public readonly cgoBaseUrl: string;
  public readonly vjfpBaseUrl: string;
  public readonly amplifyDomain: string;
  public readonly vjfpNGRestAPI: string;
  public readonly gaKey: string;
  public readonly socketUrl: string;
  public readonly enableAnalytics: boolean;
  public readonly stripePaymentLink: string;

  constructor () {
    this.cgoBaseUrl = this.getStringEnv('REACT_APP_CGO_BASE_URL');
    this.vjfpBaseUrl = this.getStringEnv('REACT_APP_VJFP_BASE_URL');
    this.amplifyDomain = this.getStringEnv('REACT_APP_AMPLIFY_DOMAIN');
    this.vjfpNGRestAPI = this.getStringEnv('REACT_APP_VJFP_NG_REST_API');
    this.gaKey = this.getStringEnv('REACT_APP_GA_KEY');
    this.socketUrl = this.getStringEnv('REACT_APP_SOCKET_URL');
    this.enableAnalytics = this.getBoolEnv('REACT_APP_ENABLE_ANALYTICS');
    this.stripePaymentLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK || '';
  }

  private getStringEnv (key: string): string {
    const value = process.env[key];
    if (!value) {
      throw new Error(`Environment variable ${key} is not set.`);
    }
    return value;
  }

  private getBoolEnv (key: string): boolean {
    const value = process.env[key];
    if (value === undefined || value === '') {
      throw new Error(`Environment variable ${key} is not set.`);
    }
    return value === 'true';
  }
}

export const config = new Config();
